'use strict';
const isEmptyGroup = require('../../content/is-empty-group'),
	alignGroup = require('./align-group'),
	combineVerticalSubtrees = require('./combine-vertical-subtrees'),
	combineCondensedVerticalSubtrees = require('./combine-condensed-vertical-subtrees'),
	isEmpty = require('@mindmup/js-utils/src/is-empty');
module.exports  = function calculateTopDownLayout(aggregate, dimensionProvider, margin) {
	const isGroup = function (node) {
			return node.attr && node.attr.group;
		},
		isCondensed = (node) => node.attr?.condensed,
		toNode = function (idea, level, parentId) {
			const dimensions = dimensionProvider(idea, level),
				{id, attr} = idea,
				node = Object.assign({level: level, verticalOffset: 0, title: isGroup(idea) ? '' : idea.title}, dimensions, {id, attr});
			if (parentId) {
				node.parentId = parentId;
			}
			return node;
		},
		//TODO: adds some complexity to the standard traverse function - includes parent id, omits post order, skips groups
		traverse = function (idea, predicate, level, parentId, forceCondensed) {
			const childResults = {},
				shouldIncludeSubIdeas = !(isEmpty(idea.ideas) || (idea.attr && idea.attr.collapsed));

			level = level || 1;
			if (shouldIncludeSubIdeas) {
				Object.keys(idea.ideas).forEach((subNodeRank) => {
					const condensed = isCondensed(idea) || forceCondensed,
						newLevel = (isGroup(idea) || condensed) ? level : level + 1,
						result = traverse(idea.ideas[subNodeRank], predicate, newLevel, idea.id, condensed);
					if (result) {
						childResults[subNodeRank] = result;
					}
				});
			}
			return predicate(idea, childResults, level, parentId, forceCondensed);
		},
		traversalLayout = function (idea, childLayouts, level, parentId, forceCondensed) {
			const node = toNode(idea, level, parentId);
			let result;
			if (isGroup(node) && !isEmpty(idea.ideas)) {
				result = combineVerticalSubtrees(node, childLayouts, margin.h, true);
				alignGroup(result, idea, margin.h);
			} else if ((forceCondensed || isCondensed(node))) {
				result = combineCondensedVerticalSubtrees(node, childLayouts, {h: margin.ch, v: margin.cv});
			} else {
				result = combineVerticalSubtrees(node, childLayouts, margin.h);
			}
			return result;
		},
		traversalLayoutWithoutEmptyGroups = function (idea, childLayouts, level, parentId, forceCondensed) {
			return (idea === aggregate || !isEmptyGroup(idea)) && traversalLayout(idea, childLayouts, level, parentId, forceCondensed);
		},
		setLevelHeights = function (nodes, levelHeights) {
			Object.values(nodes).forEach((node) => {
				const verticalAdjustment = (node.bubble && node.bubble.y) || 0;
				node.y = levelHeights[node.level - 1] + node.verticalOffset - verticalAdjustment;
				delete node.verticalOffset;
			});
		},
		getLevelHeights = function (nodes) {
			const maxHeights = [],
				heights = [];
			let level,
				totalHeight = 0;
			Object.values(nodes).forEach((node) => {
				maxHeights[node.level - 1] = Math.max(maxHeights[node.level - 1] || 0, node.height + node.verticalOffset);
			});
			totalHeight = maxHeights.reduce((memo, item) => {
				return memo + item;
			}, 0) + (margin.v *  (maxHeights.length - 1));

			heights[0] = Math.round(-0.5 * totalHeight);

			for (level = 1; level < maxHeights.length; level++) {
				heights [level] = heights [level - 1] + margin.v + maxHeights[level - 1];
			}
			return heights;
		},
		tree = traverse(aggregate, traversalLayoutWithoutEmptyGroups);

	setLevelHeights(tree.nodes, getLevelHeights(tree.nodes));

	return tree.nodes;
};

